
export default new VueRouter({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/pages/home/home'],resolve),
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/pages/index'],resolve),
      redirect:'/introduce',
      children:[{
        path: '/introduce',
        name: 'introduce',
        component: resolve => require(['@/pages/index/introduce'],resolve)
      },{
        path: '/xvuebutton',
        name: 'xvuebutton',
        component: resolve => require(['@/pages/index/xvuebutton'],resolve)
      },{
        path: '/xvuestart',
        name: 'xvuestart',
        component: resolve => require(['@/pages/index/xvuestart'],resolve)
      },{
        path: '/xvueupdatelog',
        name: 'xvueupdatelog',
        component: resolve => require(['@/pages/index/xvueupdatelog'],resolve)
      },{
        path: '/xvuedialog',
        name: 'xvuedialog',
        component: resolve => require(['@/pages/index/xvuedialog'],resolve)
      },{
        path: '/xvuemessage',
        name: 'xvuemessage',
        component: resolve => require(['@/pages/index/xvuemessage'],resolve)
      },{
        path: '/xvuelayout',
        name: 'xvuelayout',
        component: resolve => require(['@/pages/index/xvuelayout'],resolve)
      },{
        path: '/xvuebadge',
        name: 'xvuebadge',
        component: resolve => require(['@/pages/index/xvuebadge'],resolve)
      },{
        path: '/xvuerate',
        name: 'xvuerate',
        component: resolve => require(['@/pages/index/xvuerate'],resolve)
      },{
        path: '/xvuecounter',
        name: 'xvuecounter',
        component: resolve => require(['@/pages/index/xvuecounter'],resolve)
      },{
        path: '/xvueradio',
        name: 'xvueradio',
        component: resolve => require(['@/pages/index/xvueradio'],resolve)
      },{
        path: '/xvuecheckbox',
        name: 'xvuecheckbox',
        component: resolve => require(['@/pages/index/xvuecheckbox'],resolve)
      },{
        path: '/xvueloading',
        name: 'xvueloading',
        component: resolve => require(['@/pages/index/xvueloading'],resolve)
      },{
        path: '/xvueprogress',
        name: 'xvueprogress',
        component: resolve => require(['@/pages/index/xvueprogress'],resolve)
      },{
        path: '/xvuemenu',
        name: 'xvuemenu',
        component: resolve => require(['@/pages/index/xvuemenu'],resolve)
      },{
        path: '/xvuecollapse',
        name: 'xvuecollapse',
        component: resolve => require(['@/pages/index/xvuecollapse'],resolve)
      },{
        path: '/xvuetabs',
        name: 'xvuetabs',
        component: resolve => require(['@/pages/index/xvuetabs'],resolve)
      },{
        path: '/xvuelazyload',
        name: 'xvuelazyload',
        component: resolve => require(['@/pages/index/xvuelazyload'],resolve)
      },{
        path: '/xvuesponsor',
        name: 'xvuesponsor',
        component: resolve => require(['@/pages/index/xvuesponsor'],resolve)
      },{
        path: '/xvuetag',
        name: 'xvuetag',
        component: resolve => require(['@/pages/index/xvuetag'],resolve)
      },{
        path: '/xvueinput',
        name: 'xvueinput',
        component: resolve => require(['@/pages/index/xvueinput'],resolve)
      },{
        path: '/xvuepagination',
        name: 'xvuepagination',
        component: resolve => require(['@/pages/index/xvuepagination'],resolve)
      }]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js